import axios from 'axios';

const apiClient = axios.create({
	baseURL: `${import.meta.env.VITE_API_HOST}/api/v1`,
});

apiClient.interceptors.request.use((config) => {
	const token = localStorage.getItem('token');
	if (token) {
		config.headers.Authorization = token;
	}
	return config;
});

// Absolutize err.config.url — consumers (e.g. isFailSilently) new URL()-parse
// it, which throws on the relative urls this instance is called with.
// ToDo: Delete once all axios calls use apiClient and consumers match relative paths.
apiClient.interceptors.response.use(undefined, (error: unknown) => {
	if (axios.isAxiosError(error) && error.config) {
		error.config.url = apiClient.getUri({ ...error.config, params: undefined });
	}

	return Promise.reject(error);
});

export default apiClient;
